import React, { useState } from "react";
import { firebase, cheq, db, database } from "../../firebaseConfig";
import { BrowserRouter as Link } from "react-router-dom";
import { useAuthState } from 'react-firebase-hooks/auth';

import { Button } from "react-bootstrap";
import FooterNew from "../../Footers/Footer";
import Login from "../../Login";
import ClientDetails from "../components/clientDetails";
import Eye from "../components/eye";
import TnC from "../components/tnc";

import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

import dayjs from "dayjs";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import FooterNext from "../../Footers/FooterNext";
import SafeplanTermsAndConditions from "./descrptions/safeplanTermsAndConditions";
import DescriptionEyeCheckupCamp from "./descrptions/descrptionEyeCheckupCamp";

export default function EyeCheckup(){
  // Inputs


  const [user] = useAuthState(cheq);

  const [todayDate, setTodayDate] = useState(new Date());
  const [reqDate, setReqDate] = useState(new Date());


  const [cityName, setCityName] = useState("");
  const [headCount, setHeadCount] = useState("");
  const [budgetPP, setBudgetPP] = useState("");

  const [otherInfo, setOtherInfo] = useState("");

  const [orgName, setOrgName] = useState("");
  const [orgRepName, setOrgRepName] = useState("");
  const [orgRepDesignation, setRepDesignation] = useState("");
  const [orgRepOfficialEmail, setOrgRepOfficialEmail] = useState("");
  const [orgCompleteAddress, setOrgCompleteAddress] = useState("");

  const cityOptions = [
    { label: 'Bengaluru' },
    { label: 'Delhi' },
    { label: 'Hyderabad' },
    { label: 'Mumbai' },
    { label: 'Pune' },
  ];

  const headCountOptions = [
    { label: 'less than 50' },
    { label: '50-100' },
    { label: '100-500' },
    { label: '500-1000' },
    { label: '1000-5000' },
    { label: 'more than 5000' },
  ];

  const budgetOptions = [
    { label: 'INR 200 - INR 500 per person' },
    { label: 'INR 500 - INR 1000 per person' },
    { label: 'INR 1000 - INR 1500 per person' },
    { label: 'INR 1500 - INR 2000 per person' },
    { label: 'INR 2000 - INR 2500 per person' },
    { label: 'above INR 2500 per person' },
  ];

  function postRequest() {

    if(cityName === ""){
      alert("Please enter City");
      return;
    }

    if(headCount === ""){
      alert("Please enter Head Count (Approx.)");
      return;
    }

    if(budgetPP === ""){
      alert("Please enter budget");
      return;
    }

    if(orgName === "" || orgRepName === "" || orgRepDesignation === "" || orgRepOfficialEmail === "" ||
    orgCompleteAddress === ""){
      alert("Please enter Organization Details");
      return;
    }

    db.collection("eye-safeplan").add({

      PosterPhone: cheq.currentUser.phoneNumber,
      city: cityName,
      headCount: headCount,
      budgetPP: budgetPP,

      otherInfo: otherInfo,
      orgName: orgName,
      orgRepName: orgRepName,
      orgRepDesignation: orgRepDesignation,
      orgRepOfficialEmail: orgRepOfficialEmail,
      orgCompleteAddress: orgCompleteAddress,

      todayDate:todayDate, 
      requestDate: dayjs(reqDate).format('LL'),
      Time: firebase.firestore.Timestamp.now().toDate().toString(),
      
    });

    database.ref("onlinerequest/safeplan/eye").push({


      PosterPhone: cheq.currentUser.phoneNumber,
      city: cityName,
      headCount: headCount,
      budgetPP: budgetPP,

      otherInfo: otherInfo,
      orgName: orgName,
      orgRepName: orgRepName,
      orgRepDesignation: orgRepDesignation,
      orgRepOfficialEmail: orgRepOfficialEmail,
      orgCompleteAddress: orgCompleteAddress,

      todayDate:todayDate, 
      requestDate: dayjs(reqDate).format('LL'),
      Time: firebase.firestore.Timestamp.now().toDate().toString(),

    }).catch(alert);



    window.location.replace('https://rzp.io/l/drplanete-eye-chkp');
   
    //alert("Request Placed Successfully!!")
    /*alert("city Name - " + cityName + "\n" + headCount + "\n" + budgetPP + "\n" +
    orgName + "\n" + orgRepName + "\n" + orgRepDesignation + "\n" + orgRepOfficialEmail + "\n" + 
    orgCompleteAddress + "\n" + dayjs(todayDate).format('L') + "\n" + dayjs(reqDate).format('LL'));

    */
  }

  return (
    user ? <>
    
    {/*<div>
      <div>
        
        <img
        className="w-full h-[440px] object-cover"
        style={{width:"1600px", height:"300px"}}
        src="https://firebasestorage.googleapis.com/v0/b/admin-5d27b.appspot.com/o/safeplan%2Fweb-heads%2Fweb-%20eye%20checkup.png?alt=media&token=5222ae0d-d852-42d2-97b6-2b198f9c8194"
        alt=""
      /></div>
      <div >

        <div class="container body-content border-1 border-indigo-600" style={{ marginTop: "35px", marginBottom: "35px" }}>

          <div class="container body-content" style={{ marginTop:"25px" , marginBottom: "35px" }}>
            <center><Autocomplete
              disablePortal
              id="combo-box-demo"
              options={cityOptions}
              sx={{ width: 500 }}
              onChange={(event, value) => setCityName(value.label)}
              renderInput={(params) => <TextField {...params} label="Select City" />
              }
            /></center>
          </div>

          <div class="container body-content" style={{ marginTop: "45px", marginBottom: "45px" }}>
            <div>
              <div class="container body-content" style={{ marginTop: "35px" }}>

                <div class="columns-2" style={{ marginTop: "15px", marginBottom: "45px" }}>

                  <center>
                    <div style={{ marginTop: "15px" }}>
                      <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        options={headCountOptions}
                        sx={{ width: 400 }}
                        onChange={(event, value) => setHeadCount(value.label)}
                        renderInput={(params) => <TextField {...params} label="Head Count" />}
                      />
                    </div>

                    <div style={{ marginTop: "15px" }}>
                      <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        options={budgetOptions}
                        sx={{ width: 400 }}
                        onChange={(event, value) => setBudgetPP(value.label)}
                        renderInput={(params) => <TextField {...params} label="Budget(Per Head)" />}
                      />
                    </div>
                  </center>
                </div>
              </div>
            </div>
          </div>

          <div>
            <center><div style={{ marginTop: "45px" }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker

                  label="Date"
                  value={reqDate}
                  onChange={(newValue) => {
                    setReqDate(newValue);
                  }}
                  toolbarFormat="ddd DD MMMM"
                  showToolbar
                  renderInput={(params) => <TextField {...params}/>}
                />
              </LocalizationProvider>
            </div>
            <p>You selected {dayjs(reqDate).format('LL')}</p>
            </center></div>

          <div style={{ marginTop: "15px", marginBottom: "15px" }}>
            <TextField id="outlined-basic"
              multiline fullWidth
              maxRows={4}
              label="Any other info" variant="outlined" onChange={(e) => setOtherInfo(e.target.value)}/>
          </div>


        </div>
      </div>

      <div >

        <div class="container body-content border-1 border-indigo-600" style={{ marginTop: "15px", marginBottom: "35px" }}>
          <div style={{ marginTop: "35px", marginBottom: "15px", width: "450px" }}>
            <TextField id="outlined-basic" fullWidth label="Organization Name" variant="outlined"  onChange={(e) => setOrgName(e.target.value)}/>
          </div>
          <div style={{ marginTop: "35px", marginBottom: "15px" }}>
            <TextField id="outlined-basic" fullWidth label="Organization Representative Name" variant="outlined" onChange={(e) => setOrgRepName(e.target.value)} />
          </div>
          <div style={{ marginTop: "35px", marginBottom: "15px" }}>
            <TextField id="outlined-basic" fullWidth label="Organization Representative Designation" variant="outlined" onChange={(e) => setRepDesignation(e.target.value)}/>
          </div>

          <div style={{ marginTop: "35px", marginBottom: "15px" }}>
            <TextField id="outlined-basic" fullWidth label="Representative Official Email ID" variant="outlined" onChange={(e) => setOrgRepOfficialEmail(e.target.value)}/>
          </div>
          <div style={{ marginTop: "35px", marginBottom: "15px" }}>
            <TextField id="outlined-basic"
              multiline fullWidth
              maxRows={4}
              label="Organization Address" variant="outlined" onChange={(e) => setOrgCompleteAddress(e.target.value)}/>
          </div>

        </div>
      </div>

      <div>
        <div class="container body-content border-1 border-indigo-600">
          <div style={{ marginTop: "25px", marginBottom: "25px" }}>
            <center>
              <Button variant="primary" size="lg" onClick={postRequest}>Post Request</Button>
            </center>
          </div>
        </div>
      </div>
      <div><FooterNext/></div>
    </div> */}

<div>

  <DescriptionEyeCheckupCamp/>
<div className="ecf-container">
     

      <div className="ecf-form-wrapper">
        <Autocomplete
          disablePortal
          options={cityOptions}
          onChange={(event, value) => setCityName(value?.label)}
          renderInput={(params) => <TextField {...params} label="Select City" fullWidth />}
        />

        <div className="ecf-dual-inputs">
          <Autocomplete
            disablePortal
            options={headCountOptions}
            onChange={(event, value) => setHeadCount(value?.label)}
            renderInput={(params) => <TextField {...params} label="Head Count" fullWidth />}
          />
          
          <Autocomplete
            style={{marginTop:"20px"}}
            disablePortal
            options={budgetOptions}
            onChange={(event, value) => setBudgetPP(value?.label)}
            renderInput={(params) => <TextField {...params} label="Budget (Per Head)" fullWidth />}
          />
          
        </div>

        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label="Date"
            value={reqDate}
            onChange={(newValue) => setReqDate(newValue)}
            renderInput={(params) => <TextField {...params} fullWidth />}
          />
        </LocalizationProvider>
        <p className="ecf-selected-date">You selected {dayjs(reqDate).format("LL")}</p>

        <TextField
          label="Any other info"
          multiline
          maxRows={4}
          fullWidth
          onChange={(e) => setOtherInfo(e.target.value)}
        />
      </div>

      <div className="ecf-form-wrapper">
        <TextField
          label="Organization Name"
          fullWidth
          onChange={(e) => setOrgName(e.target.value)}
          className="ecf-input"
        />
        <TextField
          label="Organization Representative Name"
          fullWidth
          onChange={(e) => setOrgRepName(e.target.value)}
          className="ecf-input"
        />
        <TextField
          label="Organization Representative Designation"
          fullWidth
          onChange={(e) => setRepDesignation(e.target.value)}
          className="ecf-input"
        />
        <TextField
          label="Representative Official Email ID"
          fullWidth
          onChange={(e) => setOrgRepOfficialEmail(e.target.value)}
          className="ecf-input"
        />
        <TextField
          label="Organization Address"
          multiline
          fullWidth
          maxRows={4}
          onChange={(e) => setOrgCompleteAddress(e.target.value)}
          className="ecf-input"
        />
      </div>

      <SafeplanTermsAndConditions/>
      <div className="ecf-submit-section">
       <Button variant="primary" size="lg" onClick={postRequest}>Post Request</Button>         
      </div>

     

      {/* Inline plain CSS */}
      <style>
        {`
          .ecf-container {
            background-color: white;
            padding: 16px;
            font-family: sans-serif;
          }

          .ecf-banner {
            width: 100%;
            max-height: 300px;
            object-fit: cover;
            margin-bottom: 20px;
          }

          .ecf-form-wrapper {
            max-width: 90%;
            margin: auto;
            padding: 16px;
          }

          .ecf-dual-inputs {
            
            flex-direction: column;
            gap: 20px;

            margin: 20px 0;
            width:100%;
          }

          .ecf-selected-date {
            margin-top: 10px;
            margin-bottom: 20px;
            font-style: italic;
            text-align: center;
          }

          .ecf-input {
            margin-top: 25px;
          }

          .ecf-submit-section {
            text-align: center;
            margin: 30px 0;
          }

          @media (min-width: 768px) {
            .ecf-dual-inputs {
              flex-direction: row;
            }
          }
        `}
      </style>
    </div>
    <FooterNext />
    </div>
    
    </> : <Login/>
  );
}
